import { Link } from "react-router-dom";
import Dignitary from "../components/Dignitary";
import { useContext } from "react";
import { schoolContext } from "../contexts/SchoolContextProvider";
import { useBackgroundImage } from "../utilities/mediautilities";
import { useTranslation } from "react-i18next";
import { I18N_KEYS } from "../languages/PlaceHolder.js";

const Dignitaries = () => {
    const { schoolDetails } = useContext(schoolContext);
    const { t } = useTranslation();
    const bgUrl = useBackgroundImage(schoolDetails?.dignataries?.fileUrl);

    return (
        <>
            <section
                className="relative bg-cover bg-center py-20 px-6 mb-10"
                style={{ backgroundImage: `url(${bgUrl})` }}
            >
                <div className="absolute inset-0 bg-black/50"></div>

                <div className="relative z-10 common-container">
                    <div className="rounded-lg text-left">
                        <h1 className="text-4xl md:text-5xl font-bold mb-4 text-accent">
                            {t(I18N_KEYS.DIGNATARIESPAGENAME)}
                        </h1>
                        <p className="text-lg md:text-xl text-accent">
                            <Link to="/" className="hover:text-primary">
                                {t(I18N_KEYS.HOMEPAGENAME)}
                            </Link>{" "}
                            &gt; {t(I18N_KEYS.DIGNATARIESPAGENAME)}
                        </p>
                    </div>
                </div>
            </section>
            <Dignitary />
        </>
    );
}
export default Dignitaries;